import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // Oturum süresi dolduğu için buraya yönlendirildiyse bunu söyle
  const [error, setError] = useState(() => {
    const n = sessionStorage.getItem('loginNotice');
    if (n) sessionStorage.removeItem('loginNotice');
    return n || '';
  });
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);   // "Şifremi unuttum" modu
  const [forgotMsg, setForgotMsg] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate(/^tasks[.-]/.test(window.location.hostname) ? '/overview' : '/today');
    } catch (err) {
      setError(!err.response ? 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.'
        : err.response.status === 401 ? 'Email veya şifre hatalı'
        : 'Giriş şu an yapılamıyor, biraz sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const sendReset = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setForgotMsg('');
    try {
      const r = await api.post('/auth/forgot-password', { email }, { silent: true });
      setForgotMsg(r.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'İstek gönderilemedi, biraz sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0E0F11' }}>
      <div style={{ background: '#17191C', padding: '40px', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 4px 24px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div className="brand brand--lg" style={{ cursor: 'default', marginTop: 10 }}>
            <span className="brand__word">BOLDRANKS</span>
            <span className="brand__sig">CRM</span>
          </div>
        </div>
        {error && (
          <div style={{ background: '#450a0a', color: '#fca5a5', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
            {error}
          </div>
        )}
        {forgot ? (
          <form onSubmit={sendReset}>
            <p style={{ color: '#9A9A92', fontSize: 14, margin: '0 0 16px', lineHeight: 1.5 }}>
              E-posta adresinizi girin; @boldranks.com adresinize şifre sıfırlama bağlantısı gönderelim (1 saat geçerli).
            </p>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus placeholder="ad@boldranks.com"
              style={{ width: '100%', padding: '10px 12px', background: '#0E0F11', border: '1px solid #2A2D32', borderRadius: '8px', color: '#F2EFE6', fontSize: '14px', boxSizing: 'border-box', marginBottom: 16 }}
            />
            {forgotMsg && <div style={{ color: '#34D399', fontSize: 14, marginBottom: 16, lineHeight: 1.5 }}>{forgotMsg}</div>}
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: '12px', background: '#D4FF3A', color: '#0E0F11', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Gönderiliyor...' : 'Sıfırlama bağlantısı gönder'}
            </button>
            <button type="button" onClick={() => { setForgot(false); setForgotMsg(''); setError(''); }}
              style={{ width: '100%', marginTop: 12, background: 'none', border: 'none', color: '#9A9A92', cursor: 'pointer', fontSize: 14 }}>
              Giriş ekranına dön
            </button>
          </form>
        ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ color: '#9A9A92', fontSize: '14px', display: 'block', marginBottom: '6px' }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: '10px 12px', background: '#0E0F11', border: '1px solid #2A2D32', borderRadius: '8px', color: '#F2EFE6', fontSize: '14px', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ color: '#9A9A92', fontSize: '14px', display: 'block', marginBottom: '6px' }}>Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: '100%', padding: '10px 12px', background: '#0E0F11', border: '1px solid #2A2D32', borderRadius: '8px', color: '#F2EFE6', fontSize: '14px', boxSizing: 'border-box' }}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#D4FF3A', color: '#0E0F11', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
          <button type="button" onClick={() => { setForgot(true); setError(''); }}
            style={{ width: '100%', marginTop: 12, background: 'none', border: 'none', color: '#9A9A92', cursor: 'pointer', fontSize: 14 }}>
            Şifremi unuttum
          </button>
        </form>
        )}
      </div>
    </div>
  );
}